import { CSSProperties } from 'react'

const styles: {
  container: CSSProperties
  card: CSSProperties
  titleRow: CSSProperties
  title: CSSProperties
  divider: CSSProperties
  footerRow: CSSProperties
} = {
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: '#1b1b1b',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#2b2b2b',
    width: '80%',
    maxWidth: 500,
    maxHeight: 500,
    borderRadius: 16,
    padding: 20,
    gap: 32,
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'center',
  },
  title: {
    fontSize: 24,
    textTransform: 'uppercase',
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: 'red',
  },
  footerRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}

export default styles
